// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import Enums from '../Enums';

export class ActualsProjectMonthlyBreakdownSummary {
  readonly name: string;
  readonly month: string;
  readonly status: Enums.ActualsPerformanceStatus;
  readonly varianceMix: string | null;
  readonly varianceAsphalt: string | null;
  readonly varianceAggregate: string | null;
  readonly actualVolumeMix: string | null;
  readonly actualVolumeAsphalt: string | null;
  readonly actualVolumeAggregate: string | null;
  readonly backlogVolumeMix: string | null;
  readonly backlogVolumeAsphalt: string | null;
  readonly backlogVolumeAggregate: string | null;
  readonly plannedVolumeMix: string | null;
  readonly plannedVolumeAsphalt: string | null;
  readonly plannedVolumeAggregate: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.name = data.name === undefined ? '' : data.name;
    this.month = data.month === undefined ? '' : data.month;
    this.status = data.status === undefined ? Enums.ActualsPerformanceStatus.AtRisk : data.status;
    this.varianceMix = data.varianceMix === undefined ? null : data.varianceMix;
    this.varianceAsphalt = data.varianceAsphalt === undefined ? null : data.varianceAsphalt;
    this.varianceAggregate = data.varianceAggregate === undefined ? null : data.varianceAggregate;
    this.actualVolumeMix = data.actualVolumeMix === undefined ? null : data.actualVolumeMix;
    this.actualVolumeAsphalt =
      data.actualVolumeAsphalt === undefined ? null : data.actualVolumeAsphalt;
    this.actualVolumeAggregate =
      data.actualVolumeAggregate === undefined ? null : data.actualVolumeAggregate;
    this.backlogVolumeMix = data.backlogVolumeMix === undefined ? null : data.backlogVolumeMix;
    this.backlogVolumeAsphalt =
      data.backlogVolumeAsphalt === undefined ? null : data.backlogVolumeAsphalt;
    this.backlogVolumeAggregate =
      data.backlogVolumeAggregate === undefined ? null : data.backlogVolumeAggregate;
    this.plannedVolumeMix = data.plannedVolumeMix === undefined ? null : data.plannedVolumeMix;
    this.plannedVolumeAsphalt =
      data.plannedVolumeAsphalt === undefined ? null : data.plannedVolumeAsphalt;
    this.plannedVolumeAggregate =
      data.plannedVolumeAggregate === undefined ? null : data.plannedVolumeAggregate;
  }

  static zero(): ActualsProjectMonthlyBreakdownSummary {
    const zeroValues: ExcludeMethodsDeep<ActualsProjectMonthlyBreakdownSummary> = {
      name: '',
      month: '',
      status: Enums.ActualsPerformanceStatus.AtRisk,
      varianceMix: null,
      varianceAsphalt: null,
      varianceAggregate: null,
      actualVolumeMix: null,
      actualVolumeAsphalt: null,
      actualVolumeAggregate: null,
      backlogVolumeMix: null,
      backlogVolumeAsphalt: null,
      backlogVolumeAggregate: null,
      plannedVolumeMix: null,
      plannedVolumeAsphalt: null,
      plannedVolumeAggregate: null,
    };
    return new ActualsProjectMonthlyBreakdownSummary(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************
  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type ActualsProjectMonthlyBreakdownSummaryWireFormat = {
  name: string;
  month: string;
  status: string;
  varianceMix: string | null;
  varianceAsphalt: string | null;
  varianceAggregate: string | null;
  actualVolumeMix: string | null;
  actualVolumeAsphalt: string | null;
  actualVolumeAggregate: string | null;
  backlogVolumeMix: string | null;
  backlogVolumeAsphalt: string | null;
  backlogVolumeAggregate: string | null;
  plannedVolumeMix: string | null;
  plannedVolumeAsphalt: string | null;
  plannedVolumeAggregate: string | null;
};

type NewActualsProjectMonthlyBreakdownSummaryProps = PartialDeep<
  ActualsProjectMonthlyBreakdownSummary,
  { recurseIntoArrays: true }
>;
export const NewActualsProjectMonthlyBreakdownSummary: (
  props: NewActualsProjectMonthlyBreakdownSummaryProps,
) => ActualsProjectMonthlyBreakdownSummary = (props) =>
  new ActualsProjectMonthlyBreakdownSummary(props);

type NewActualsProjectMonthlyBreakdownSummaryFromWireFormatProps = PartialDeep<
  ActualsProjectMonthlyBreakdownSummaryWireFormat,
  { recurseIntoArrays: true }
>;
export const NewActualsProjectMonthlyBreakdownSummaryFromWireFormat: (
  props: NewActualsProjectMonthlyBreakdownSummaryFromWireFormatProps,
) => ActualsProjectMonthlyBreakdownSummary = (props) =>
  new ActualsProjectMonthlyBreakdownSummary(props);
